module.exports = __webpack_public_path__ + "img/BAY.a9ff9f8b.png";